import create, {SetState, GetState} from "zustand";
import { User } from "../component/security/User";


interface UserStore {
    isAuthenticated: boolean;
    shouldResetPassword: boolean;

    currentUser: User;
    
    setCurrentUser: (user: User) => void;
    connectUser: () => void;
    disconnectUser: () => void;

    currentEntity: string;
    isBackendOperation: boolean,
    setIsBackendOperation: (backendOpearion: boolean) => void;

    setCurrentEntity: (entity: string) => void;
    getCurrentEntity: () => string;

    currentObjectDataDef: string;
    setCurrentObjectDataDef: (objectDataDef: string) => void;
    getCurrentObjectDataDef: () => string;

    currentObjectKey: string;
    setCurrentObjectKey: (objectKey: string) => void;
    getCurrentObjectKey: () => string;
    
    currentObjectsKey: string[];
    setCurrentObjectsKey: (objectKey: string[]) => void;
    getCurrentObjectsKey: () => string[];

    getToken: () => string;
    getRefreshToken: () => string;

    refreshUserToken: ( accesToken: string) => void;
    
    // todos: Todo[];
    // addTodo: (description: string) => void;
    // removeTodo: (id: string) => void;
    // toggleCompletedState: (id: string) => void;
  }


export const useUserStore = create<UserStore>(
   (set : SetState<UserStore>, get: GetState<UserStore>) => ({
    // initial state
    isAuthenticated: false, 
    shouldResetPassword: false,

    currentUser: {
      isConnected: false,
      shouldResetPassword: false,
      token: '',      
      refreshToken: '',
      language: '',
      login: '',
      userName: '',
      customerAgencyEnumerationCode: '',
      agencies: [],
      groupPolicies: [],
      userMenus: []
    },

    setCurrentUser : (user: User) : void => {
      //const {isAuthenticated} = get();
      
      set(state => ({...state, currentUser: user, isAuthenticated: user.isConnected, shouldResetPassword: user.shouldResetPassword }) );
    },    

    connectUser : () : void => {
      //const {isAuthenticated} = get();
      set(state => ({ ...state, isAuthenticated: true }) );
    },
    disconnectUser : () : void => {
      //const {isAuthenticated} = get();
      set(state => ({...state, currentUser: {...state.currentUser, token: '', isConnected:false, userMenus:[]}  ,isAuthenticated: false }));
    },

    currentEntity: '',
    isBackendOperation: false,
    setCurrentEntity : (entity: string) : void => {
      //const {isAuthenticated} = get();
      set(state => ({...state, currentEntity: entity }) );
    },
    getCurrentEntity: () : string => get().currentEntity,
    setIsBackendOperation : (backendOpearion: boolean) : void => {
      //const {isAuthenticated} = get();
      set(state => ({...state, isBackendOperation: backendOpearion }) );
    },

    currentObjectDataDef: '',
    setCurrentObjectDataDef : (objectDataDef: string) : void => {
      //const {isAuthenticated} = get();
      set(state => ({...state, currentObjectDataDef: objectDataDef }) );
    },
    getCurrentObjectDataDef: () : string => get().currentObjectDataDef,

    currentObjectKey: '',
    setCurrentObjectKey : (objectKey: string) : void => {
      //const {isAuthenticated} = get();
      set(state => ({...state, currentObjectKey: objectKey }) );
    },
    getCurrentObjectKey: () : string => get().currentObjectKey,

    currentObjectsKey: [],
    setCurrentObjectsKey : (objectsKey: string[]) : void => {
      //const {isAuthenticated} = get();
      set(state => ({...state, currentObjectsKey: objectsKey }) );
    },
    getCurrentObjectsKey: () : string[] => get().currentObjectsKey,

    getToken: () : string => get().currentUser.token,

    getRefreshToken: () : string => get().currentUser.refreshToken,

    refreshUserToken: ( accessToken: string): void => {
      
      set(state => ({...state, currentUser: {...state.currentUser, token: accessToken} }));
    }
          
    //set(state => {isAuthenticated: true}),
    // methods for manipulating state
    
  }));